import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
@Pipe({
  name: 'phoneAreaCode'
} )
export class PhoneAreaCodePipe implements PipeTransform {

  constructor(
    private authService: AuthService
  ){}
  transform( value: string, args?: any ): any {
    if ( ! value ) return;
    let _value: string = value;
    let plus: string = '+';
    const areaCode: string = this.authService.currentUser ? plus + this.authService.currentUser.areaCode : '';
    const areaCodeLength = areaCode.length;
    
    // remove any non-numeric chars.
    _value = _value.replace(/[^0-9]/g,'');

    // remove initial zero if set.
    if ( _value.indexOf('0') ===  0 ){
      _value = _value.substring(1, value.length );
    }

    // if area code is alreadty set, simply return the value.
    if ( _value.substring( 0, areaCodeLength ) === areaCode ){
      return _value;
    }

    return areaCode + _value || '';
  }

}
